var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MembreRemarque } from 'admin/classes/MembreRemarque.class';
import { Album } from 'album/classes/Album.class';
import axiosInstance from '../../store/AxiosSingleton';
import { Membre } from 'membre/classes/Membre.class';
import { MembreDroit } from 'membre/classes/MembreDroit.class';
import { Sortie } from 'sortie/classes/Sortie.class';
import { RaisonSuppression } from 'admin/classes/RaisonSuppression.class';
import { Alerte } from 'common/classes/Alerte.class';
import { Thematique } from 'forum/classes/Thematique.class';
import { BoutiqueCommande } from 'boutique/classes/BoutiqueCommande.class';
import { BoutiqueProduit } from 'boutique/classes/BoutiqueProduit.class';
export class AdminService {
    /**
     * Vérifie si l'utilisateur connecté est un administrateur
     * @return True si l'utilisateur est un administrateur, false sinon
     */
    static checkAdmin() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'CHECK_ADMIN',
                },
            });
            return content;
        });
    }
    /**
     * Charge tous les membres avec des informations administrateurs
     * @param request Filtres de la requête
     * @return Liste des membres et leur nombre total
     */
    static loadMembers(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: AdminService.rubModule, action: 'ADMIN_LOAD_MEMBERS' }, request),
            });
            return {
                membres: content.membres.map((member) => new Membre(member.infoPublic, member.infoPrive, member.infoAdmin)),
                total: content.total,
            };
        });
    }
    /**
     * Charger un membre avec les informations publiques, privées et admin
     * @param idMembre Identifiant du membre
     * @return Membre avec toutes ses informations
     */
    static loadMember(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_MEMBER',
                    idMembre,
                },
            });
            return new Membre(content.infoPublic, content.infoPrive, content.infoAdmin);
        });
    }
    /**
     * Bloque les emails fournis
     * @param emails Liste des emails à bloquer
     * @return Les emails qui n'ont pas pu être bloqués
     */
    static blockEmails(emails) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                emails,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_BLOCK_EMAILS',
                },
            });
            return content;
        });
    }
    /**
     * Change l'état de mailKO
     * @param idMembre Identifiant du membre
     * @return True si action réussie, false sinon.
     */
    static switchEmailKo(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMembre }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_SWITCH_EMAIL_KO',
                },
            });
            return content;
        });
    }
    /**
     * Rend un membre premium ou lui enlève la fonctionnalité premium
     * @param idMembre Identifiant du membre
     * @return True si l'opération a fonctionné
     */
    static switchPremium(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                idMembre,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_SWITCH_PREMIUM',
                },
            });
            return content;
        });
    }
    /**
     * Charge les remarques d'un membre
     * @param idMembre Identifiant du membre
     * @return Remarques récupérées
     */
    static loadMemberRemarque(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_MEMBER_REMARQUES',
                    idMembre,
                },
            });
            return content.map((remarque) => new MembreRemarque(remarque));
        });
    }
    /**
     * Ajoute une remarque à un membre
     * @param request Identifiant du membre et le message de la remarque à ajouter
     * @return La remarque ajoutée
     */
    static addMemberRemarque(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { request }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_ADD_MEMBER_REMARQUE',
                },
            });
            return content.map((remarque) => new MembreRemarque(remarque));
        });
    }
    /**
     * Supprime le membre
     * @param idMembre Identifiant du membre à supprimer
     * @param idRaison Identifiant de la raison de la suppression
     * @param commentaire *(optionnel)* Commentaire de la suppression
     * @return True si l'opération a réussie
     */
    static deleteMember(idMembre, idRaison, commentaire) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_DELETE_MEMBER',
                    idMembre,
                    idRaison,
                    commentaire,
                },
            });
            return content;
        });
    }
    /**
     * Débanni un membre
     * @param idMembre Identifiant du membre
     * @return True si l'opération a fonctionné
     */
    static undeleteMember(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                idMembre,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_UNDELETE_MEMBER',
                },
            });
            return content;
        });
    }
    /**
     * Modifie le rôle d'un membre
     * @param request L'identifiant du membre et l'identifiant du droit qu'on souhaite lui attribuer
     * @return True si la modification a réussie
     */
    static changeMemberRole(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { request }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_CHANGE_MEMBER_ROLE',
                },
            });
            return content;
        });
    }
    /**
     * Créer un compte pour un utilisateur
     * @param member Membre à créer
     * @return True si l'envoi du mail de création de compte a réussi
     */
    static addMember(member) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { member }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_ADD_MEMBER',
                },
            });
            return content;
        });
    }
    /**
     * Charge les albums avec des informations administrateurs
     * @param request Filtres à appliquer
     * @return Albums chargés, sorties en lien et nombre total d'albums
     */
    static loadAlbums(request) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_ALBUMS',
                    request,
                },
            });
            return {
                albums: content.albums.map((album) => new Album(album)),
                total: content.total,
                sorties: (_b = (_a = content === null || content === void 0 ? void 0 : content.sorties) === null || _a === void 0 ? void 0 : _a.map((sortie) => new Sortie(sortie))) !== null && _b !== void 0 ? _b : null,
            };
        });
    }
    /**
     * Cherche des albums en fonction de filtres
     * @param request Filtres à appliquer
     * @return Albums trouvés
     */
    static searchAlbums(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: AdminService.rubModule, action: 'ADMIN_SEARCH_ALBUMS' }, request),
            });
            return content.map((album) => new Album(album));
        });
    }
    /**
     * Charge les statistiques des albums pour un membre donné
     * @param idMembre Identifiant du membre
     * @return Statistiques récupérées
     */
    static loadAlbumsStatistics(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_ALBUMS_STATISTICS',
                    idMembre,
                },
            });
            return content;
        });
    }
    /**
     * Récupère le nom des sorties créées par le membre
     * @param idMembre Identifiant du membre
     * @return Identifiant et nom des sorties
     */
    static loadMemberSortieNameList(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_MEMBER_SORTIE_NAME_LIST',
                    idMembre,
                },
            });
            return content;
        });
    }
    /**
     * Valide un album
     * @param album Album validé
     * @param notifications Notification à envoyer à l'auteur de l'album
     * @param sendMail Si true envoi un mail aux contacts de l'auteur de l'album
     * @return true si action réussie
     */
    static validateAlbum(album, notifications, sendMail) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                album: album.toRaw(),
                notifications,
                sendMail,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_VALIDATE_ALBUM',
                },
            });
            return content;
        });
    }
    /**
     * On récupère tous les rôles en dessous de celui de l'utilisateur connecté
     * @return Rôles récupérés
     */
    static loadMemberRoles() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_MEMBER_ROLE',
                },
            });
            return content.map((membreDroit) => new MembreDroit(membreDroit));
        });
    }
    /**
     * Renvoi toutes les statistiques des sorties de l'application
     * @return Statistiques récupérées
     */
    static loadSortiesStatistics() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_SORTIES_STATISTICS',
                },
            });
            return content;
        });
    }
    /**
     * Récupère en BDD les sorties d'un membre en fonction de filtres
     * @param request Paramètre de la requête vers le back
     * @return La liste des sorties et le nombre de total de sorties
     */
    static adminLoadSorties(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_SORTIES',
                    request,
                },
            });
            return {
                sorties: content.sorties.map((sortie) => new Sortie(sortie)),
                total: content.total,
            };
        });
    }
    /**
     * Récupère une sortie avec des informations administrateurs
     * @param idSortie Identifiant de la sortie
     * @return Sortie récupérée
     */
    static loadSortie(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_SORTIE',
                    idSortie,
                },
            });
            return new Sortie(content);
        });
    }
    /**
     * Valide une sortie en BDD
     * @param sortie Sortie à valider
     * @param notification Dictionnaire des notifications
     * @param sendMail Si true envoi un mail aux contacts de l'auteur de l'album
     * @return True si validation réussi, false sinon
     */
    static validateSortie(sortie, notification, sendMail) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!sortie) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                sortie: sortie.toRaw(),
                notification,
                sendMail,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_VALIDATE_SORTIE',
                },
            });
            return content;
        });
    }
    /**
     * Charge la liste des raisons de suppressions
     * @param rubrique Rubrique dont on souhaite charger les raisons
     * @return La liste des raisons de suppressions
     */
    static loadRaisonSuppression(rubrique) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'LOAD_RAISON_SUPPRESSION',
                    rubrique,
                },
            });
            return content.map((p) => new RaisonSuppression(p));
        });
    }
    /**
     * Charge les alertes recencées dans l'application en fonction de filtres
     * @param request Filtres de la requête
     * @return Alertes récupérées et nombre d'alertes total
     */
    static loadAlertes(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: AdminService.rubModule, action: 'ADMIN_LOAD_ALERTES' }, request),
            });
            return {
                alertes: content.alertes.map((alerte) => new Alerte(alerte)),
                total: content.total,
            };
        });
    }
    /**
     * Traiter une alerte
     * @param idAlerte Identifiant de l'alerte
     * @return True si l'opération a réussi, false sinon
     */
    static moderateAlerte(idAlerte) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idAlerte }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_MODERATE_ALERTE',
                },
            });
            return content;
        });
    }
    /**
     * Récupère les thématiques du forum
     * @param request filtre de la recherche
     * @return La liste des thématiques
     */
    static adminLoadThematiques(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_THEMATIQUES',
                    request,
                },
            });
            return content.map((thematique) => new Thematique(thematique));
        });
    }
    /**
     * Récupère des statistiques sur le forum
     * @return Statistiques récupérées
     */
    static adminLoadForumStats() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_FORUM_STATS',
                },
            });
            return content;
        });
    }
    /**
     * Ajoute une nouvelle thématique
     * @param thematique Thematique à insérer
     * @return True si l'opération a fonctionné, false sinon
     */
    static addForumThematique(thematique) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!thematique) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                thematique,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_SAVE_FORUM_THEMATIQUE',
                },
            });
            return content;
        });
    }
    /**
     * Supprime une thématique
     * @param request Informations relatives à la suppression
     * @return Identifiant de la thématique supprimée
     */
    static adminDeleteThematique(request) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!request) {
                return null;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                request,
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_DELETE_FORUM_THEMATIQUE',
                },
            });
            return content;
        });
    }
    /**
     * Change l'ordre des thématiques
     * @param thematiqueList Liste des thématiques à réordonner
     * @returns True si l'opération a réussi, false sinon
     */
    static adminOrderThematiques(thematiqueList) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                request: thematiqueList.map((thematique) => thematique.toRaw()),
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_ORDER_FORUM_THEMATIQUE',
                },
            });
            return content.map((thematique) => new Thematique(thematique));
        });
    }
    /**
     * Met à jour la relation d'une sortie avec un album
     * @param sortie Sortie à modifier
     * @return True si modification réussie, false sinon
     */
    static adminUpdateSortieLinkedAlbum(sortie) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!sortie) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                sortie: sortie.toRaw(),
            }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_UPDATE_SORTIE_LINKED_ALBUM',
                },
            });
            return content;
        });
    }
    /**
     * Récupère les factures
     * @param params Les paramètres de recherche
     * @return Les factures et le total
     */
    static adminLoadFactures(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: AdminService.rubModule, action: 'ADMIN_LOAD_FACTURES' }, params),
            });
            return {
                factures: content.factures.map((facture) => new BoutiqueCommande(facture)),
                total: content.total,
            };
        });
    }
    /**
     * Récupère les données de stripe de la facture
     * @param idCommande Identifiant de la commande
     * @return Les données de stripe concernant la facture
     */
    static adminLoadStripeData(idCommande) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_STRIPE_DATA',
                    idCommande,
                },
            });
            return content.data[0];
        });
    }
    /**
     * Récupère les statistiques sur la boutique
     * @return Les statistiques
     */
    static adminLoadBoutiqueStatistiques() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_BOUTIQUE_STATISTIQUES',
                },
            });
            return content;
        });
    }
    /**
     * Récupère les membres en fonction d'un filtre de recherche
     * @param params le filtre de recherche
     * @return Les membres
     */
    static adminLoadSearchMembers(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    params,
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_SEARCH_MEMBERS',
                },
            });
            return content.map((membre) => new Membre(membre.infoPublic));
        });
    }
    /**
     * Récupère les produits en fonction de filtre de recherche
     * @param query Le filtre de recherche
     * @return Les produits
     */
    static adminLoadProduits(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    query,
                    rub: AdminService.rubModule,
                    action: 'ADMIN_LOAD_PRODUITS',
                },
            });
            return content.map((produit) => new BoutiqueProduit(produit));
        });
    }
    /**
     * Insère une commande
     * @param commande La commande
     * @returns L'identifiant de la commande
     */
    static adminSaveCommand(commande) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { commande: commande.toRaw() }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_SAVE_COMMAND',
                },
            });
            return content;
        });
    }
    /**
     * Récupère les données de facturation sur un intervalle de temps
     * @param startDate Date de début
     * @param endDate Date de fin
     * @returns Les données de facturations
     */
    static adminExportFacture(startDate, endDate) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_EXPORT_FACTURE',
                    startDate,
                    endDate,
                },
            });
            return content;
        });
    }
    /**
     * Insère une catégorie pour les annonces
     * @param annonce La catégorie à insérer
     * @return True si action réussie
     */
    static saveCategorie(categorie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { categorie: categorie.toRaw() }, {
                params: {
                    rub: AdminService.rubModule,
                    action: 'ADMIN_SAVE_ANNONCE_CATEGORIE',
                },
            });
            if (content === null) {
                return null;
            }
            return content;
        });
    }
}
AdminService.rubModule = 'admin';
//# sourceMappingURL=data:application/json;base64,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